// Helper functions for gathering translations
import uiLocale from './UILocale.js';


export const getTranslation = (key) => {
  if (key === 'avmSingleDeal') {
    return uiLocale.getString('component.productlisting.avmSingleDeal');
  }
  if (key === 'avmMultiDeals') {
    return uiLocale.getString('component.productlisting.avmMultiDeals');
  }
  if (key === 'noReviewsTranslation') {
    return uiLocale.getString('component.productlisting.noReviewsLabel');
  }
  if (key === 'forDeliveryPlaceTranslation') {
    return uiLocale.getString('component.productlisting.forLabel');
  }
  if (key === 'fromDateTranslation') {
    return uiLocale.getString('component.productlisting.fromDateLabel');
  }
  if (key === 'toDateTranslation') {
    return uiLocale.getString('component.productlisting.toLabel');
  }
  if (key === 'mainProductWasPriceTranslation') {
    return uiLocale.getString('component.productlisting.mainProductWasLabel');
  }
  if (key === 'mainProductCurrentPriceTranslation') {
    return uiLocale.getString('component.productlisting.nowLabel');
  }
  if (key === 'separateSellingPriceTranslation') {
    return uiLocale.getString('component.productlisting.separate_selling_price');
  }
  if (key === 'wasPriceTranslation') {
    return uiLocale.getString('component.productlisting.wasLabel');
  }
  if (key === 'savingsPriceTranslation') {
    return uiLocale.getString('component.productlisting.saveLabel');
  }
  if (key === 'inStorePriceTranslation') {
    return uiLocale.getString('component.productlisting.priceInstoreLabel');
  }
  if (key === 'perMonthTranslation') {
    return uiLocale.getString('component.productlisting.perMonthLabel');
  }
  if (key === 'productDescriptionTitleClosedTranslation') {
    return uiLocale.getString('component.productlisting.briefProductDescLabel');
  }
  if (key === 'productDescriptionTitleOpenedTranslation') {
    return uiLocale.getString('component.productlisting.closeLabel');
  }
  if (key === 'productDescriptionLinkTranslation') {
    return uiLocale.getString('component.productlisting.findOutMoreLabel');
  }
  if (key === 'ourExpertsLoveTranslation') {
    return uiLocale.getString('component.productlisting.expertLoveLabel');
  }
  if (key === 'onlineOnlyTranslation') {
    return uiLocale.getString('component.productlisting.onlineOnlyLabel');
  }
  if (key === 'downloadProductTranslation') {
    return uiLocale.getString('component.productlisting.downloadLabel');
  }
  if (key === 'emailMeBackFirstLineTranslation') {
    return uiLocale.getString('component.productlisting.noDeliveryLabel');
  }
  if (key === 'emailMeBackLinkTranslation') {
    return uiLocale.getString('component.productlisting.emailBackLabel');
  }
  if (key === 'countdownSaleSearchTranslation') {
    return uiLocale.getString('component.productlisting.flashSaleLabel');
  }
  if (key === 'webExclusivePriceTranslation') {
    return uiLocale.getString('component.productlisting.webExclusiveLabel');
  }
  if (key === 'countdownSaleTranslation') {
    return uiLocale.getString('component.productlisting.countDownSaleLabel');
  }
  if (key === 'tooltipTextTranslate') {
    return uiLocale.getString('component.comparecheckbox.please_remove_product');
  }
  if (key === 'searchAgainLink') {
    return uiLocale.getString('component.mcd.postcodechecker.search.again.link');
  }
  if (key === 'changeLocationLink') {
    return uiLocale.getString('component.mcd.postcodechecker.change.location.link');
  }
  if (key === 'locationFoundTopSearchLabel') {
    return uiLocale.getString('tourguide.postcodecheck.inline-callout.content');
  }
  if (key === 'locationFoundFilterSearchLabel') {
    return uiLocale.getString('component.mcd.postcodechecker.items.available');
  }
  if (key === 'postcodeCheckerLabel') {
    return uiLocale.getString('component.mcd.postcodechecker.check.availability');
  }
  if (key === 'postcodeCheckerPlaceholder') {
    return uiLocale.getString('component.mcd.postcodechecker.enter.postcode');
  }
  if (key === 'postcodeCheckerPending') {
    return uiLocale.getString('component.mcd.postcodechecker.pending');
  }
  if (key === 'previousSearchesLabel') {
    return uiLocale.getString('component.mcd.postcodechecker.previous.searches');
  }
  if (key === 'wrongLocationInputMessage') {
    return uiLocale.getString('component.mcd.postcodechecker.no.locations.found.for.input');
  }
  if (key === 'geolocationOrLabel') {
    return uiLocale.getString('component.mcd.postcodechecker.checker.or');
  }
  if (key === 'geolocationButtonLabel') {
    return uiLocale.getString('component.mcd.postcodechecker.use.my.current.location');
  }
  if (key === 'postcodeCheckerSearchingError') {
    return uiLocale.getString('component.mcd.postcodechecker.timeouterror');
  }
  if (key === 'geolocationGatheringError') {
    return uiLocale.getString('component.mcd.postcodechecker.geoerror');
  }
  if (key === 'moreDealSingle') {
    return uiLocale.getString('component.avm.moreDealSingle');
  }
  if (key === 'moreDealsMulti') {
    return uiLocale.getString('component.avm.moreDealsMulti');
  }
  if (key === 'endsToday') {
    return uiLocale.getString('component.avm.endsToday');
  }
  if (key === 'endsTomorrow') {
    return uiLocale.getString('component.avm.endsTomorrow');
  }
  if (key === 'endsSoon') {
    return uiLocale.getString('component.avm.endsSoon');
  }
  if (key === 'moreDetails') {
    return uiLocale.getString('component.avm.more_details');
  }
  if (key === 'dealsAvailable') {
    return uiLocale.getString('component.avm.dealsAvailable');
  }
  if (key === 'onedealAvailable') {
    return uiLocale.getString('component.avm.onedealAvailable');
  }

  return '';
};

export const getEmailWhenBackFormTranslation = (key) => {


  if (key === 'title') {
    return uiLocale.getString('component.emailbackform.title');
  }
  if (key === 'legend') {
    return uiLocale.getString('component.emailbackform.legend');
  }
  if (key === 'selectLabel') {
    return uiLocale.getString('component.emailbackform.select_label');
  }
  if (key === 'name') {
    return uiLocale.getString('component.emailbackform.name');
  }
  if (key === 'surname') {
    return uiLocale.getString('component.emailbackform.surname');
  }
  if (key === 'email') {
    return uiLocale.getString('component.emailbackform.email');
  }
  if (key === 'submit') {
    return uiLocale.getString('component.emailbackform.submit');
  }
  if (key === 'mandatoryText') {
    return uiLocale.getString('component.emailbackform.mandatory_text');
  }

  return '';
};

export const getCompareCheckboxTranslation = () => {
  const translations = {
    tooltipText: uiLocale.getString('component.comparecheckbox.please_remove_product'),
    checkboxLabel: uiLocale.getString('component.comparepanel.compare_button'),
    defaultLabel: uiLocale.getString('component.comparepanel.upToItems')
  };

  return translations;
};

export const getPersonTitleTranslation = () => (
  Object.entries(uiLocale.getString('component.emailbackform.select_titles')))
  .map((civilityItem) => ({ id: civilityItem[0], label: civilityItem[1] })

  );
